import { PageSection, Tab } from 'components';
import { MainBlock } from 'containers/pages/for-businesses/components/constructor/MainBlock';
import { SecondaryBlock } from 'containers/pages/for-businesses/components/constructor/SecondaryBlock';
import {
    Container,
    SecondaryBlocksContainer,
} from 'containers/pages/for-businesses/components/constructor/styled';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { CSSObject } from 'styled-components';
import { Title } from './styled';
import { Lang } from 'types/index';
import { langMapper } from 'utils/index';
import i18n from 'config/i18n';

const sectionConfig = {
    CWrap: {
        css: {
            paddingTop: 250,
            paddingBottom: 60,

            '@media(max-width: 1023px)': {
                paddingTop: 150,
                paddingBottom: 27,
            },
        },
    },
    ContentArea: {
        css: {
            display: 'block',
            position: 'relative',
        },
    },
};

interface ConstructorProps {
    bgImagePath: string;
    title: string;
    bgStyles?: CSSObject;
}

export const Constructor: FC<ConstructorProps> = ({
    bgImagePath,
    title,
    bgStyles,
}) => {
    const { t } = useTranslation('pages/home');
    const langDomain = langMapper[i18n.language];

    const tabs = {
        tabs: [
            {
                key: 'individuals',
                isActive: true,
                body: (
                    <>
                        <MainBlock
                            config={{
                                title: t('individuals-title-1'),
                                subtitle: t('individuals-subtitle-1'),
                                imagePath:
                                    '/assets/images/bussiness/laptop.png',
                                link: '/courses/n/n/1/n/n',
                                imageStyles: {
                                    backgroundPositionX: '151%',
                                    backgroundPositionY: '19%',
                                    backgroundSize: '75%',
                                    '@media(max-width: 1023px)': {
                                        backgroundPosition: '50%',
                                    },
                                },
                            }}
                        />
                        <SecondaryBlocksContainer>
                            <SecondaryBlock
                                config={{
                                    title: t('individuals-title-2'),
                                    subtitle: t('individuals-subtitle-2'),
                                    link: '/courses/n/n/2/n/n',
                                }}
                            />
                            <SecondaryBlock
                                config={{
                                    title: t('individuals-title-3'),
                                    subtitle: t('individuals-subtitle-3'),
                                    link: '/courses/n/n/6/n/n',
                                }}
                            />
                        </SecondaryBlocksContainer>
                        <SecondaryBlocksContainer>
                            <SecondaryBlock
                                config={{
                                    title: t('individuals-title-4'),
                                    subtitle: t('individuals-subtitle-4'),
                                    link: '/courses/n/n/5/n/n',
                                }}
                            />
                            <SecondaryBlock
                                config={{
                                    title: t('individuals-title-5'),
                                    subtitle: t('individuals-subtitle-5'),
                                    link:
                                        langDomain === Lang.En
                                            ? '/courses/n/n/1/n/1'
                                            : '/courses/n/n/8/n/n',
                                }}
                            />
                        </SecondaryBlocksContainer>
                    </>
                ),
                title: <span>{t('individuals')}</span>,
            },
            {
                key: 'company',
                body: (
                    <>
                        <MainBlock
                            config={{
                                title: t('company-title-1'),
                                subtitle: t('company-subtitle-1'),
                                imagePath:
                                    '/assets/images/bussiness/communicate.jpg',
                                link: '/courses/n/n/1/n/n',
                                imageStyles: {
                                    backgroundPositionX: '360px',
                                    backgroundPositionY: '12%',
                                    '@media(max-width: 1023px)': {
                                        backgroundPositionX: '120px',
                                    },
                                },
                            }}
                        />
                        <MainBlock
                            config={{
                                withoutGradient: true,
                                title: t('company-title-2'),
                                subtitle: t('company-subtitle-2'),
                                link: '/courses/n/n/5/n/n',
                                imageStyles: {
                                    backgroundColor: '#f4f7fa',
                                },
                            }}
                        />
                        {/* <SecondaryBlocksContainer>
                            <SecondaryBlock
                                config={{
                                    title: t('company-title-2'),
                                    subtitle: t('company-subtitle-2'),
                                    link: '/courses/n/n/5/n/n',
                                }}
                            />
                            <SecondaryBlock
                                config={{
                                    title: t('company-title-4'),
                                    subtitle: t('company-subtitle-4'),
                                    link: '/courses/n/n/4/n/n',
                                }}
                            />
                        </SecondaryBlocksContainer> */}
                    </>
                ),
                title: <span>{t('company')}</span>,
            },
        ],
        styles: {
            textColor: '#1d1d1b',
            rootStyles: `
                    border-radius: 10px 10px 0px 0px;
            `,
            menuStyles:
                'padding: 0; gap: 40px; padding: 0 70px; justify-content: center;' +
                '@media only screen and (max-width: 1023px) { flex-direction: row !important; border-bottom: none !important; gap: 10px !important; padding: 0; flex-wrap: wrap; justify-content: flex-start; }',
            menuItemStyles:
                'padding: 20px 0; font-size: 21px; line-height: 24px; font-weight: 300; &:after { background: #3DE8CA; bottom: -2px; }' +
                '@media only screen and (max-width: 1023px) { &:after { display: none; }; font-size: 16px; line-height: 14px; padding: 5px 12px; background: #ECEFF3; color: #000000; white-space: nowrap; ' +
                'border-radius: 24px; width: auto !important; &.is-active { padding-right: 26px; background: linear-gradient(45deg, #3DE8CA 38.74%, #33FF77 100%); &:before { content: "✖"; position: absolute; right: 10px; top: 50%; transform: translateY(-50%); font-size: 12px; }; } }',
            bodyStyles: 'padding: 40px 0 0 0;',
        },
    };

    return (
        <Container
            bgImagePath={bgImagePath}
            bgStyles={bgStyles}
            afterColor={'#fff'}>
            <PageSection config={sectionConfig}>
                <Title>{title}</Title>
                <Tab {...tabs} />
            </PageSection>
        </Container>
    );
};
